/* eslint-disable react/no-array-index-key */
import { useTranslation } from 'react-i18next'

import {
  type UpdateMovePayload,
  useCurrentMove,
  useUpdateMoveAction,
} from '../../../modules/moves'
import { useNavigate } from '../../../modules/navigation'
import { type EditableSectionProps } from '../../EditableSections/editableSections.type'
import AddressesForm from '../../forms/editmove/AddressesForm'
import Route from '../../../app/Route.enum'
import {
  errorNotification,
  successNotification,
  warningNotification,
} from '../../ToastNotifications'
import { useErrorFormatter } from '../../errors/useErrorFormatter'
import AddressRow from './AddressRow'
import { mergeClassName } from '../../../utils/mergeClassName'
import { getUsedLocations } from '../../../modules/moves/core/locations.utils'

const AddressesSection: React.FC<EditableSectionProps> = ({
  isEditing,
  onClose,
  wide,
}) => {
  const { t } = useTranslation()
  const move = useCurrentMove()
  const [updateMove] = useUpdateMoveAction()
  const { navigate } = useNavigate()
  const formatError = useErrorFormatter()
  const usedLocations = getUsedLocations(move)

  const hasStops = usedLocations.length > 2

  const onSubmit = async (data: UpdateMovePayload) => {
    try {
      const hasSelection = !!move.selectedQuote
      const updatedMove = await updateMove(data)
      onClose()
      navigate(Route.Move)
      successNotification((
        <>
          { t('components.move.addresses.success') }
          <div className="font-bold">
            { t('components.move.quoteRecalculated') }
          </div>
        </>
      ))

      if (hasSelection && !updatedMove.selectedQuote) {
        warningNotification(t('components.move.unselectedQuote'))
      }
    } catch (error) {
      errorNotification(formatError(error))
    }
  }

  if (isEditing) {
    return (
      <AddressesForm
        onSubmit={onSubmit}
        onCancel={onClose}
        wide={wide && !hasStops}
      />
    )
  }

  return (
    <div className={mergeClassName(
      'my-2 flex flex-col gap-4 lg:my-4 lg:flex-row lg:gap-y-6',
      hasStops && 'lg:flex-col',
    )}
    >
      { usedLocations.map((location) => {
        return (
          <AddressRow
            key={location.id}
            move={move}
            locationId={location.id}
            wide={hasStops}
          />
        )
      }) }
    </div>
  )
}

export default AddressesSection
